import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ReceiveSubplantStockDto } from './receive-subplant-stock.dto';

export class AllReceiveSubplantStockResponseModel extends GlobalResponseObject{
    data?: ReceiveSubplantStockDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ReceiveSubplantStockDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }

}
